module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/tables_lv_mobile-5016366b578582d2ed77b1ec4cfc3dce.webp";